import React from 'react';

import { Container, Title, Button, Image } from 'ui/components/styled';
import { AuthLayout } from 'ui/components/layouts';
import { useUser } from 'hooks';

export const TFAStart = () => {
  const { challenges, redirectTo } = useUser();

  return (
    <AuthLayout show={challenges.required} justifyContent="start">
      <Container width="80%" maxWidth="480px" height="auto" top="15%">
        <Container alignItems="center" mb="xl">
          <Image alt="2FA" src="/assets/img/2FA.png" />
        </Container>
        <Title mb="m">Your security matters</Title>
        <Title type="h3" variant="grey" mb="m">
          With two-factor authentication (2FA) you will protect your account using both something
          you know (your password) and something you have (like your mobile phone).
        </Title>
        <Title type="h3" variant="grey">
          Let’s get started
        </Title>
        <Button type="submit" my="m" onClick={() => redirectTo('/2fa/setup')}>
          NEXT
        </Button>
      </Container>
    </AuthLayout>
  );
};
